import { render, staticRenderFns } from "./Heard.vue?vue&type=template&id=00da44da&"
import script from "./Heard.vue?vue&type=script&lang=js&"
export * from "./Heard.vue?vue&type=script&lang=js&"
import style0 from "./Heard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports